<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12">
        <b-button-group>
          <b-button :variant="'primary'" class="mb-3">
            <i class="las la-address-book"></i>
            Hồ sơ
          </b-button>
          <b-button :variant="'primary'" class="mb-3" @click="$router.push({name:'activity-log.list'})">
            <i class="las la-list-alt"/>
            Lịch sử hoạt động
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col lg="5">
        <iq-card>
          <template v-slot:body>
            <div class='text-center'>
              <h4>{{ userInfo.username }}</h4>
            </div>
          </template>
        </iq-card>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Thông tin cá nhân</h4>
          </template>
          <template v-slot:body>
            <b-list-group flush>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h5>Tên tài khoản</h5>
                {{ userInfo.fullname }}
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h5>Email</h5>
              </b-list-group-item>
              <b-list-group-item class="d-flex justify-content-between align-items-center">
                <h5>Số điện thoại</h5>
              </b-list-group-item>
            </b-list-group>
          </template>
        </iq-card>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Cập nhật 2FA</h4>
          </template>
          <template v-slot:body>
            <span>Nhằm tăng tính tiện dụng và bảo mật cá nhân, chúng tôi cung cấp tính năng bảo mật 2 lớp (2FA) đây là tính năng sẽ cần cho một số tác vụ trong hệ thống như:</span>
            <div class="ml-4">
              <li><b>Rút tiền</b></li>
            </div>
            <hr/>
            <two-factor-authentication-modal/>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="7">
        <iq-card v-show="userInfo.change_username === 1">
          <template v-slot:headerTitle>
            <h4 class="card-title">Đổi tên đăng nhập</h4>
          </template>
          <template v-slot:body>
            <span>Nhằm tăng tính tiện dụng và bảo mật cá nhân, chúng tôi hỗ trợ người dùng thay đổi <b>Tên tài khoản</b> để đăng nhập vào hệ thống.</span>
            <hr>
            <b style="text-decoration: underline">Lưu ý:</b>
            <div class="ml-4">
              <li>Bạn chỉ có 1 lần duy nhất để thay đổi tên tài khoản này. Vui lòng chọn lựa và kiểm tra kĩ trước khi
                  xác nhận.
              </li>
              <li>Tên đăng nhập chỉ chứa kí tự Chữ (a-Z) và Số (0-9)</li>
            </div>
            <hr>
            <ValidationObserver v-slot="{ handleSubmit, invalid }">
              <b-form @submit.prevent="handleSubmit(onSubmitChangeUsername)">
                <ValidationProvider rules="required" v-slot="{ errors }" name="new_username">
                  <b-form-group label="Tên đăng nhập">
                    <b-form-input type="text" v-model="username.new_username"/>
                    <span class="text-warning">{{ errors[0] }}</span>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{ errors }" name="password">
                  <b-form-group label="Mật khẩu xác nhận">
                    <b-form-input type="password" v-model="username.password"/>
                    <span class="text-warning">{{ errors[0] }}</span>
                  </b-form-group>
                </ValidationProvider>
                <b-button :disabled="invalid" type="submit" variant="primary" class="mb-3">
                  <i class="la la-check"/>
                  Xác nhận
                </b-button>
              </b-form>
            </ValidationObserver>
          </template>
        </iq-card>
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title">Đổi mật khẩu</h4>
          </template>
          <template v-slot:body>
            <li>Mật khẩu phải có từ <b>8 đến 20 kí tự</b></li>
            <li>Mật khẩu phải có ít nhất <b>1 kí tự thường</b></li>
            <li>Mật khẩu phải có ít nhất <b>1 kí tự Hoa</b></li>
            <li>Mật khẩu phải có ít nhất <b>1 kí tự đặc biệt</b></li>
            <hr>
            <ValidationObserver v-slot="{ handleSubmit, invalid }">
              <b-form @submit.prevent="handleSubmit(onSubmitChangePassword)">
                <ValidationProvider rules="required" v-slot="{ errors }" name="old_password">
                  <b-form-group label="Mật khẩu cũ">
                    <b-form-input type="password" v-model="password.current_password"/>
                    <span class="text-warning">{{ errors[0] }}</span>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider rules="required" v-slot="{ errors }" name="password">
                  <b-form-group label="Mật khẩu">
                    <b-form-input type="password" v-model="password.password"/>
                    <span class="text-warning">{{ errors[0] }}</span>
                  </b-form-group>
                </ValidationProvider>
                <ValidationProvider rules="required|confirmed:password" v-slot="{ errors }" name="password_confirm">
                  <b-form-group label="Xác nhận mật khẩu">
                    <b-form-input type="password" v-model="password.password_confirm"/>
                    <span class="text-warning">{{ errors[0] }}</span>
                  </b-form-group>
                </ValidationProvider>
                <b-button :disabled="invalid" type="submit" variant="primary" class="mb-3">
                  <i class="las la-check"/>
                  Xác nhận
                </b-button>
              </b-form>
            </ValidationObserver>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { findash } from '../../config/pluginInit'
import { localize } from 'vee-validate'
import { mapActions, mapGetters } from 'vuex'
import api from '../../store/api'
import TwoFactorAuthenticationModal from '@/components/application/account/TwoFactorAuthenticationModal'

export default {
  name: 'ProfileEdit',
  components: { TwoFactorAuthenticationModal },
  mounted () {
    findash.index()
  },
  created () {
    localize('en', {
      fields: {
        'new_username': { required: 'Tên đăng nhập không được để trống' },
        'old_password': { required: 'Mật khẩu cũ không được để trống' },
        'password': { required: 'Mật khẩu không được để trống' },
        'password_confirm': {
          required: 'Mật khẩu xác nhận không được để trống',
          confirmed: 'Xác nhận mật khẩu không chính xác'
        }
      }
    })
  },
  computed: {
    ...mapGetters({
      'userInfo': 'Auth/userInfoState',
      'serverError': 'Setting/serverErrorsState'
    })
  },
  data () {
    return {
      username: {
        new_username: null,
        password: null
      },
      password: {
        current_password: null,
        password: null,
        password_confirm: null
      }
    }
  },
  methods: {
    onSubmitChangeUsername () {
      api.auth.change_username({
        'username': this.username.new_username,
        'current_password': this.username.password
      }).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Đổi tên đăng nhập thành công'
        })
        // logout
        this.logout()
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    },
    onSubmitChangePassword () {
      api.auth.change_password({
        'current_password': this.password.current_password,
        'new_password': this.password.password
      }).then((res) => {
        this.$swal({
          icon: 'success',
          title: 'Đổi mật khẩu thành công'
        })
        // logout
        this.logout()
      }).catch(() => {
        this.$swal({
          icon: 'error',
          title: 'Lỗi...',
          text: this.serverError
        })
      })
    },
    onSubmit () {

    },
    ...mapActions({
      'getMe': 'Auth/getMe',
      'logout': 'Auth/authUserLogout'
    })
  }
}
</script>
